<script setup lang="ts">

import { useRequestStore } from "@/stores/request";
import { useLocaleStore } from "@/stores/l10n";
import Input from "@/components/Input.vue";
import Button from "@/components/Button.vue";
import Textarea from "@/components/Textarea.vue";

const requestStore = useRequestStore()
const localeStore = useLocaleStore()

defineProps<{
    error?: string,
}>()

const addItem = () => {
    requestStore.form.items.push({
        product_id: null,
        name: null,
        quantity: null,
        note: null,
    })
}

const removeItem = (index: number) => {
    requestStore.form.items.splice(index, 1)
}

</script>

<template>
    <div class="col-span-full space-y-4">
        <label class="text-sm">{{ localeStore.getText('withdrawal_items') }}</label>

        <div v-if="error" class="text-xs text-primary mt-2">{{ error }}</div>

        <div class="grid grid-cols-1 gap-4 mb-4s">
            <div v-for="(item, index) in requestStore.form.items" :key="index"
                 class="grid grid-cols-1 gap-4 p-6 shadow-sm border border-solid border-gray-light rounded"
            >
                <div class="flex justify-between items-center">
                    <span class="font-bold">#{{ index + 1 }}</span>

                    <span @click="removeItem(index)">
                        <img src="../../public/icons/trash.svg" class="w-6 cursor-pointer !m-0 !p-0" alt="">
                    </span>
                </div>


                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <Input :id="`item_number_${index}`" required :label="localeStore.getText('withdrawal_product_id')" v-model="item.product_id" :disabled="requestStore.loading" :error="requestStore.errors?.[`items.${index}.product_id`]?.[0]" @clear-error="requestStore.clearError(`items.${index}.product_id`)" />
                    <Input :id="`item_name_${index}`" required :label="localeStore.getText('withdrawal_product_name')" v-model="item.name" :disabled="requestStore.loading" :error="requestStore.errors?.[`items.${index}.name`]?.[0]" @clear-error="requestStore.clearError(`items.${index}.name`)" />
                    <Input :id="`item_quantity_${index}`" required :label="localeStore.getText('withdrawal_product_quantity')" v-model="item.quantity" :disabled="requestStore.loading" :error="requestStore.errors?.[`items.${index}.quantity`]?.[0]" @clear-error="requestStore.clearError(`items.${index}.quantity`)" />
                </div>

                <Textarea :id="`item_note_${index}`" :label="localeStore.getText('withdrawal_product_note')" v-model="item.note" :disabled="requestStore.loading" :rows="2" :error="requestStore.errors?.[`items.${index}.note`]?.[0]" @clear-error="requestStore.clearError(`items.${index}.note`)" />
            </div>
        </div>

        <Button size="small" color="secondary" @click="addItem">
            <img src="../../public/icons/plus.svg" class="w-4 font-bold !mr-2" alt="" aria-hidden="true">
            {{ localeStore.getText('withdrawal_item_add') }}
        </Button>
    </div>
</template>
